// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CollateralTypeCodeApprvService = {};

CollateralTypeCodeApprvService.getCollateralTypeCodeApprvList = function (
  userInput
) {
  return lossClient({
    url: "/CollateralType/approvalItems?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default CollateralTypeCodeApprvService;
